export default "__VITE_ASSET__C2POtcsN__"